import {createSvgIcon} from '../create-svg-icon';

export const KeyboardBackspaceIcon = createSvgIcon(
  <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z" />
, 'KeyboardBackspaceOutlined');
